import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SEO from "../components/seo";

const ProjectsData = [
  { id: 1, category: "Level Wound Coil (LWC)", title: "Level Wound Coil (LWC)", image: "/static/img/portfolio/Product_Tube_LWC.webp", link: "/level_wound_coil" },
  { id: 2, category: "Copper Foil", title: "Copper Foil", image: "/static/img/portfolio/Product_Foil.webp", link: "/copper_foil" },
  { id: 3, category: "Copper Pancake", title: "Copper Pancake", image: "/static/img/portfolio/Product_Pancake.webp", link: "/copper_pancake" },
  { id: 4, category: "Copper Straigth Pipe", title: "Copper Straight Pipe", image: "/static/img/portfolio/Product_Pipe.webp", link: "/copper_straight_pipe" },
  { id: 5, category: "Copper Foil", title: "Alluminium foil for fins", image: "/static/img/portfolio/Product_Alluminium_foil_for_fins.webp", link: "/alluminum_foil_for_fins" },
  { id: 6, category: "Copper Fittings", title: "Y bend", image: "/static/img/portfolio/Product_Y.webp", link: "/y_bend" },
  { id: 7, category: "Copper Fittings", title: "C Bend", image: "/static/img/portfolio/Product_C.webp", link: "/c_bend" },
  { id: 8, category: "Copper Fittings", title: "U Bend", image: "/static/img/portfolio/Product_U.webp", link: "/u_bend" },
  { id: 9, category: "Copper Fittings", title: "Copper Tripod", image: "/static/img/portfolio/Product_Tripod.webp", link: "/copper_tripod" },
  { id: 10, category: "Copper Fittings", title: "Copper Tee", image: "/static/img/portfolio/Product_T.webp", link: "/copper_tee" },
  { id: 11, category: "Copper Fittings", title: "Copper Elbow", image: "/static/img/portfolio/Product_L.webp", link: "/copper_elbow" },
  { id: 12, category: "Copper Fittings", title: " Copper Cap", image: "/static/img/portfolio/Product_Cap.webp", link: "/copper_cap" },
  { id: 13, category: "Copper Fittings", title: "Copper Filter", image: "/static/img/portfolio/Product_Filter.webp", link: "/copper_filter" },
  { id: 14, category: "Copper Fittings", title: "Brazzing Road", image: "/static/img/portfolio/Product_Road.webp", link: "/brazzing_road" },
  { id: 15, category: "Copper Fittings", title: "NRV Valves", image: "/static/img/portfolio/Product_NRVValves.webp", link: "/nrv_valves" },
  { id: 16, category: "Copper Fittings", title: "Distributors", image: "/static/img/portfolio/Product_Distributors.webp", link: "/distributors" },
];

const CopperFoilList = () => {
  const [filter, setFilter] = useState("Copper Foil");

  // PAGINATION STATES
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  // MODAL STATES
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "" });

  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  // FILTER DATA
  const filteredProjects =
    filter === "all"
      ? ProjectsData
      : ProjectsData.filter((p) => p.category === filter);

  // RESET PAGE ON FILTER CHANGE
  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  // PAGINATION LOGIC
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProjects.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);

  // FORM SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    try {
      const payload = { ...formData };

      const res = await fetch(
        "https://karmyogienterprise.com/contact_api/popup_contact.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.json();
      setResponseMsg(result.message);

      if (result.status === "success") {
        setFormData({ name: "", email: "", phone: "" });
        setShowModal(false);
      }
    } catch (error) {
      setResponseMsg("API Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // PROJECT CLICK
  const handleProjectClick = (project) => {
    if (project.link) {
      window.location.href = project.link;
    } else {
      setModalContent({ title: project.title });
      setShowModal(true);
    }
  };

  // SHOW MODAL ON LOAD--popup
  // useEffect(() => {
  //   setModalContent({ title: "Newsletter" });
  //   setShowModal(true);
  // }, []);

  return (
    <>
    <SEO pageKey="copperFoilList" />
    <main>

       {/* Inline styles */}
      <style>
        {`
          #projectTabs .nav-link {
            border-radius: 50px;
            color: #333;
            margin: 0 5px;
          }
          #projectTabs .nav-link.active {
            background-color: #007bff;
            color: #fff;
          }
          .modal-content {
            border-radius: 10px;
            padding: 20px;
            background: #f7f9fc;
          }
          .modal-header {
            background-color: #004aad;
            color: #fff;
            border-radius: 10px;
          }
          .form-label {
            font-weight: bold;
            margin-bottom: 10px;
          }
          .form-control {
            border-radius: 10px;
            padding: 10px;
            margin-bottom: 15px;
            border: 1px solid #ccc;
          }
          .form-control:focus {
            border-color: #007bff;
            box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
          }
          .btn-primary {
            background-color: #007bff;
            border-radius: 50px;
            width: 30% !important;
            padding: 10px;
            border: none;
          }
          .btn-primary:hover {
            background-color: #0056b3;
          }
        `}
      </style>
      {/* Breadcrumb Section */}
      <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">

          <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
          <img src="/static/img/shape/breadcrumn-shape.webp" alt="" />
        </div>
        <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
          <img src="/static/img/shape/ca-line-shape.webp" alt="" />
        </div>


        <div className="container">
          <div className="ca-breadcrumb-content text-center">
            <h2 className="ca-breadcrumb-title fnw-600">Copper Foil List</h2>
            <div className="it-breadcum-link">
              <a href="/">Home</a>
              <span>
                <i className="fa-solid fa-angle-right"></i>
              </span>
              <a className="active" href="/copper_foil_list">
                Copper Foil List
              </a>
            </div>
          </div>
        </div>
      </section>
      <br />

      {/* FILTER TABS */}
      <ul className="nav nav-pills justify-content-center mb-4">
        {["all", "Level Wound Coil (LWC)", "Copper Foil", "Copper Straigth Pipe", "Copper Pancake", "Copper Fittings"].map((cat) => (
          <li className="nav-item" key={cat}>
            <button
              className={`nav-link ${filter === cat ? "active" : ""}`}
              onClick={() => setFilter(cat)}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          </li>
        ))}
      </ul>

      {/* PROJECTS GRID */}
      <div className="container">
        <div className="row">
          {currentItems.map((project) => (
            <div key={project.id} className="col-xl-3 col-md-6">
              <div
                className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
              >
               <div className="ca-single-team-img">
                  <a href={project.link}>
                    <img className="w-100 br-7" src={project.image} alt={project.title} style={{ cursor: "pointer" }}
                    />
                  </a>
               </div>

              <div className="ca-single-team-content">
                {/* <h3 className="ca-team-title">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                      {project.title}
                    </a>
                </h3> */}
                <h3 className="ca-team-title">
                <a href={project.link}>
                  {project.title}
                </a>
              </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
                
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        <div className="row">
          <div className="col-12 m-auto">
            <div className="theme-pagination text-center">
              <ul>
                <li>
                  <a onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}>
                    <i className="fa-solid fa-angle-left"></i>
                  </a>
                </li>

                {[...Array(totalPages)].map((_, index) => (
                  <li key={index}>
                    <a
                      className={currentPage === index + 1 ? "active" : ""}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </a>
                  </li>
                ))}

                <li>
                  <a
                    onClick={() =>
                      currentPage < totalPages && setCurrentPage(currentPage + 1)
                    }
                  >
                    <i className="fa-solid fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      

      <br /><br /><br />

      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{modalContent.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary w-100">
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>

          {responseMsg && <p className="pt-3">{responseMsg}</p>}
        </Modal.Body>
      </Modal>
    </main>
    </>
  );
};

export default CopperFoilList;

